import { defineComponent as _defineComponent } from 'vue'
import {EFilterOperators, FilterOperatorsBitmap, FILTERS, ISignalFilter} from "@/shared";
import {onBeforeMount, ref, watchEffect,} from "vue";

// props
interface IProps {
	filter: ISignalFilter;
	componentProps?: any;
	dataMessage?: string;
	operators?: FilterOperatorsBitmap;
}

interface IEmits {
	(e: "input", data: ISignalFilter): void;

	(e: "delete"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterOperator',
  props: {
    filter: null,
    componentProps: null,
    dataMessage: null,
    operators: null
  },
  emits: ["input", "delete"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "input", data: ISignalFilter): void;

	(e: "delete"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	filter: ISignalFilter;
	componentProps?: any;
	dataMessage?: string;
	operators?: FilterOperatorsBitmap;
};




const ComponentRef = ref<any | null>(
	null
);

// computed

// data


// methods
onBeforeMount(() => {
	switch (props.filter.type) {
		case "int":
		case "int64":
		case "uint64":
			ComponentRef.value = FILTERS["int"]
			break
		case "float32":
		case "float64":
			ComponentRef.value = FILTERS["float"]
			break
		default:
			ComponentRef.value = FILTERS[props.filter.type]
	}
})

function delFilter() {
	emit("delete")
}

// watch
watchEffect(() => {
	emit("input", props.filter.value);
});

// emits


// expose
expose({});

return { __sfc: true,props, ComponentRef, delFilter, emit, EFilterOperators }
}

})